/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shopping_Running_LowInputs */

const en_shopping_running_low = /** @type {(inputs: Shopping_Running_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restock`)
};

const de_shopping_running_low = /** @type {(inputs: Shopping_Running_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachkaufen`)
};

/**
* | output |
* | --- |
* | "Restock" |
*
* @param {Shopping_Running_LowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const shopping_running_low = /** @type {((inputs?: Shopping_Running_LowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shopping_Running_LowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_shopping_running_low(inputs)
	return en_shopping_running_low(inputs)
});